import React, { useEffect } from 'react';
import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';

import { selectApplications } from 'features/applications/applicationsSelectors';
import { fetchApplicationsData } from 'features/applications/applicationsThunks';
import { selectJobs } from 'features/jobs/jobsSelectors';
import { fetchJobsData } from 'features/jobs/jobsThunks';
import { selectTourState } from 'features/tour/tourSelectors';
import { setApplicationId, setJobId, stopTour } from 'features/tour/tourSlice';

import { useHandleJoyrideCallback } from 'hooks/tourHooks';
import { useAppDispatch } from 'hooks/useTypedRedux';

import CustomTooltip from '../CustomTooltip/CustomTooltip';

const TourContainer: React.FC = () => {
  const state = useSelector(selectTourState);
  const handleJoyrideCallback = useHandleJoyrideCallback();
  const dispatch = useAppDispatch();
  const jobs = useSelector(selectJobs);
  const applications = useSelector(selectApplications);

  const isInvalidTourState =
    state.run &&
    (state.steps.length === 0 || state.stepIndex >= state.steps.length);

  useEffect(() => {
    // dispatch(fetchJobsData());
    // dispatch(fetchApplicationsData());
  }, []);

  useEffect(() => {
    if (jobs?.[0]?.id) {
      dispatch(setJobId({ jobId: jobs[0].id }));
    }
  }, [jobs, dispatch]);

  useEffect(() => {
    if (applications?.[0]?.id) {
      dispatch(setApplicationId({ applicationId: applications[0].id }));
    }
  }, [applications, dispatch]);

  useEffect(() => {
    if (isInvalidTourState) {
      dispatch(stopTour());
    }
  }, [isInvalidTourState, dispatch]);

  if (state.steps.length === 0) {
    return null;
  }

  return (
    <Joyride
      steps={state.steps}
      run={state.run && !state.isLoading}
      stepIndex={state.stepIndex}
      continuous={true}
      tooltipComponent={CustomTooltip}
      showProgress={true}
      showSkipButton={true}
      disableOverlayClose={true}
      spotlightClicks={false}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: 'var(--brand-primary-darken)',
          zIndex: 10000
        }
      }}
    />
  );
};

export default TourContainer;
